import { InputMask } from "@components/Form/FormBlocks/Customer/Address/partials/maskedField/maskedField.component";

const zipCodeFormatting = {
    BE: {
        regex: new RegExp(/^[0-9]{4}$/),
        mask: "0000",
        placeHolderChar: "_",
    },
    FR: {
        regex: new RegExp(/^[0-9]{5}$/),
        mask: "00000",
        placeHolderChar: "_",
    },
    NL: {
        regex: new RegExp(/^[0-9]{4} [a-zA-Z]{2}$/),
        mask: "0000 aa",
        placeHolderChar: "_",
    },
    DE: {
        regex: new RegExp(/^[0-9]{5}$/),
        mask: "00000",
        placeHolderChar: "_",
    },
    LU: {
        regex: new RegExp(/^[0-9]{4}$/),
        mask: "0000",
        placeHolderChar: "_",
    },
    DEFAULT: {
        regex: new RegExp(/^[A-Za-z0-9 -]{4,8}$/),
    },
};

/**
 * Get the formatting rules for the given country, do a fall back on BE if nog found
 *
 * @param countryCode
 * @returns {*}
 */
export const getCountryFormatting = (countryCode: string = "BE"): InputMask => {
    // @ts-ignore
    const formatting = zipCodeFormatting[countryCode.toUpperCase()];
    if (formatting) {
        return formatting;
    }
    return zipCodeFormatting.DEFAULT;
};

/**
 * Check if the given zip code matches the given country formatting
 *
 * @param countryCode
 * @param zipCode
 */
export const checkCountryZipCode = (countryCode: string, zipCode: string) => {
    const countryRegex = getCountryFormatting(countryCode)?.regex;

    return countryRegex ? countryRegex.test(zipCode) : true;
};
